import fruitOpJeWerkDepth from "@/assets/images/projects/fruit-op-je-werk-depth.png";
import yeazDepth from "@/assets/images/projects/yeaz-depth.png";
import yukiDepth from "@/assets/images/projects/yuki-depth.png";

const src = `/images/projects/`;

function convertTitleToSlug(title) {
  return title
    .toLowerCase()
    .replace(/ /g, "-")
    .replace(/[^a-zA-Z0-9-]/g, "")
    .replace("!", "")
    .trim();
}

export const SERVICES = ["identity", "photo-video", "webdesign", "campaign"];

export const PROJECTS = [
  {
    title: "Fruit op je werk",

    depthImage: fruitOpJeWerkDepth,
    category: "identity",
    featured: true,
    meta: {
      deliverables: ["Landing page", "Webshop"],
      year: "2021",
    },
    content: [
      {
        name: "ProjectHeader",
        data: {
          title: "Fruit op je werk",
          paragraphHeader: "2023 - New beer brand - Website",
          paragraph:
            "Officia aliqua commodo quis. Id occaecat irure dolore enim est laboris. Irure occaecat nostrud eu.",
        },
      },
      {
        name: "ProjectNumbers",
        data: {
          titleLeft: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
          titleRight: "Impact",
          titleRightSmall: "Lorem ipsum dolor.",
          numbers: [
            {
              number: 8500,
              text: "Beers sold in The Netherlands",
            },
            {
              number: 50000,
              text: "People reached with campaigns",
            },
            {
              number: 134,
              text: "Bars and restaurants that sell Malarkey",
            },
          ],
        },
      },
      {
        name: "ProjectParagraph",
        data: "Culpa eu fugiat aute ea aute non eu. Anim incididunt elit sunt dolore ad. Elit Lorem ut amet excepteur labore adipisicing. Excepteur cillum laboris aliqua labore excepteur sint velit voluptate. Duis magna quis commodo consectetur consequat laboris eiusmod elit ipsum occaecat.",
      },
      {
        name: "ProjectImageColumn",
        data: [
          {
            src: "https://picsum.photos/seed/1/1600/900",
            width: 100,
          },
        ],
      },
      {
        name: "ProjectImageColumn",
        data: [
          {
            src: "https://picsum.photos/seed/1/1600/900",
            width: 50,
          },
          {
            src: "https://picsum.photos/seed/1/1600/900",
            width: 50,
          },
        ],
      },
      {
        name: "ProjectImageColumn",
        data: [
          {
            src: "https://picsum.photos/seed/1/1600/900",
            width: 70,
          },
        ],
      },
    ],
  },
  {
    title: "Yuki",

    depthImage: yukiDepth,
    category: "identity",
    featured: true,
    meta: {
      deliverables: ["Landing page", "Webshop"],
      year: "2021",
    },
  },
  {
    title: "Gjald",

    category: "identity",
    featured: true,
    meta: {
      deliverables: ["Landing page", "Webshop"],
      year: "2021",
    },
  },
  {
    title: "Yeaz!",

    depthImage: yeazDepth,
    category: "identity",
    featured: true,
    meta: {
      deliverables: ["Landing page", "Webshop"],
      year: "2021",
    },
  },
  {
    title: "Malarkey",

    //depthImage: malarkeyDepth,
    category: "identity",
    featured: true,
    meta: {
      deliverables: ["New bear brand", "Website"],
      year: "2023",
    },
  },
  {
    title: "Inzaken",

    category: "identity",
    //depthImage: malarkeyDepth,
    featured: true,
    meta: {
      deliverables: ["Photoshoot", "Recruitment campaign"],
      year: "2023",
    },
  },
  {
    title: "Allsetra",

    category: "identity",
    //depthImage: malarkeyDepth,
    featured: true,
    meta: {
      deliverables: ["Rebranding", "Website"],
      year: "2022",
    },
  },

  {
    category: "campaign",
    title: "Amphia",
  },
  {
    category: "campaign",
    title: "Ballie",
  },
  {
    category: "campaign",
    title: "Double double",
  },
  {
    category: "campaign",
    title: "Het Badhuys",
    folder: "het-badhuys",
    content: [
      {
        name: "ProjectHeader",
        data: {
          title: "Het badhuys",
          paragraphHeader: "2023 - New beer brand - Website",
          paragraph:
            "Officia aliqua commodo quis. Id occaecat irure dolore enim est laboris. Irure occaecat nostrud eu. ",
        },
      },
      {
        name: "ProjectImageColumn",
        data: [
          {
            src: `${src}/het-badhuys/7.jpg`,
            width: 50,
          },
          {
            src: `${src}/het-badhuys/6.jpg`,
            width: 50,
          },
        ],
      },
      {
        name: "ProjectImageColumn",
        data: [
          {
            src: `${src}/het-badhuys/4.jpg`,
            width: 100,
          },
        ],
      },
      {
        name: "ProjectParagraph",
        data: "Culpa eu fugiat aute ea aute non eu. Anim incididunt elit sunt dolore ad. Elit Lorem ut amet excepteur labore adipisicing. Excepteur cillum laboris aliqua labore excepteur sint velit voluptate. Duis magna quis commodo consectetur consequat laboris eiusmod elit ipsum occaecat.",
      },
      {
        name: "ProjectImageColumn",
        data: [
          {
            src: `${src}/het-badhuys/8.jpg`,
            width: 70,
          },
          {
            src: `${src}/het-badhuys/5.jpg`,
            width: 30,
          },
        ],
      },
      {
        name: "ProjectImageColumn",
        data: [
          {
            src: `${src}/het-badhuys/9.jpg`,
            width: 30,
          },
          {
            src: `${src}/het-badhuys/1.jpg`,
            width: 70,
          },
        ],
      },
      {
        name: "ProjectParagraph",
        data: "Culpa eu fugiat aute ea aute non eu. Anim incididunt elit sunt dolore ad. Elit Lorem ut amet excepteur labore adipisicing. Excepteur cillum laboris aliqua labore excepteur sint velit voluptate. Duis magna quis commodo consectetur consequat laboris eiusmod elit ipsum occaecat.",
      },
      {
        name: "ProjectImageColumn",
        data: [
          {
            src: `${src}/het-badhuys/3.jpg`,
            width: 100,
          },
        ],
      },

      {
        name: "ProjectNumbers",
        data: {
          titleLeft: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
          titleRight: "Impact",
          titleRightSmall: "Lorem ipsum dolor.",
          numbers: [
            {
              number: 8500,
              text: "Beers sold in The Netherlands",
            },
            {
              number: 50000,
              text: "People reached with campaigns",
            },
            {
              number: 134,
              text: "Bars and restaurants that sell Malarkey",
            },
          ],
        },
      },
    ],
  },

  {
    category: "webdesign",
    title: "Klinkhamer",
  },
  {
    category: "webdesign",
    title: "Master IT",
  },
  {
    category: "webdesign",
    title: "Ned",
  },
  {
    category: "photo-video",
    title: "Rockaseller",
  },

  {
    category: "photo-video",
    title: "Tas",
  },

  // {
  //slug: "allsetra",
  //   title: "Allsetra",

  // },
  // {
  //slug: "allsetra",
  //   title: "Danneels",

  // },

  // {
  //slug: "allsetra",
  //   title: "Inzaken",

  // },
  // {
  //slug: "allsetra",
  //   title: "Malarkey",

  // },
]
  .map((p) => ({ slug: convertTitleToSlug(p.title), ...p }))
  .map((p) => {
    const coverImage = p.folder
      ? `${src}${p.folder}/cover.jpg`
      : `${src}${p.slug}.jpg`;
    return { coverImage, ...p };
  });

export const DATA = {
  pages: {
    home: {
      hero: {},
      howWeDoIt: {
        title: "How we do it",
        text: "We are a design studio that reinvents reality for a smart and cultured future.",
        text2:
          "With design, voice and forward thinking ideas, we create worlds for brands we love.",
        cards: [
          {
            title: "Identity",
            textTop:
              "Mensen moeten in 1 sec. weten dat het om jouw merk gaat. Maar hoe blijf je onderscheidend, met zoveel indrukken? Met een sterke en heldere identiteit.",
            textBottom:
              "Dus zoeken wij naar de kern, de stickiness van jouw merk. We maken het onmiskenbaar jou en zorgen dat het blijft plakken.",
          },
          {
            title: "Impact",
            textTop:
              "Impact maken betekent zelf de toekomst vormgeven. Als creatief bureau staan wij middenin de samenleving. ",
            textBottom:
              "Wij weten precies wat er speelt, zien veranderingen al vroeg en anticiperen op wat komen gaat. Zo zorgen wij ervoor dat jouw merk de koers niet volgt, maar bepaalt.",
          },
          {
            title: "Reach",
            textTop:
              "In een wereld vol ruis wil je niet hoeven schreeuwen om een punt te maken. Wij helpen je om de juiste mensen te bereiken",
            textBottom:
              "Samen met onze partners creëren we de perfecte balans tussen impact, frequentie en bereik. Zodat jij je merk kan laten spreken.",
          },
          {
            title: "Result",
            textTop:
              "We streven vaak naar hetzelfde: groei, succes en bereik. We nemen verschillende routes, maar bewegen in dezelfde richting. Alleen, hoe maak je dan nog het verschil?",
            textBottom:
              "Wij zorgen ervoor dat jouw merk niet alleen doet wat het belooft, maar dat elke stap gericht is op concrete resultaten die je ziet en voelt. ",
          },
        ],
      },

      whatWeDo: {
        title: "What we do",
        text: "You already look great, let us make you look fantastic!",
        text2:
          "We live for great design, making you look good is our life's mission. If clothes.",
        services: [
          {
            slug: "identity",
            title: "Identity",
            text1:
              "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            text2: "Lorem ipsum dolor sit amet.",
            image: "https://picsum.photos/seed/1/1600/900",
          },
          {
            slug: "strategy",
            title: "Strategy",
            text1:
              "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            text2: "Lorem ipsum dolor sit amet.",
            image: "https://picsum.photos/seed/1/1600/900",
          },
          {
            slug: "webdesign",
            title: "Webdesign",
            text1:
              "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            text2: "Lorem ipsum dolor sit amet.",
            image: "https://picsum.photos/seed/1/1600/900",
          },
          {
            slug: "photo-video",
            title: "Photo & Video",
            text1:
              "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            text2: "Lorem ipsum dolor sit amet.",
            image: "https://picsum.photos/seed/1/1600/900",
          },
          {
            slug: "campaign",
            title: "Campaign",
            text1:
              "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            text2: "Lorem ipsum dolor sit amet.",
            image: "https://picsum.photos/seed/1/1600/900",
          },
        ],
      },
      whatWeveCreated: {
        title: "What we've created",
        text: "Take a look at our track record",
        text2:
          "Nine is an independent design studio that reinvents reality for a smart and cultured future. With design, voice and forward thinking ideas, we create worlds for brands we love.",
        projects: PROJECTS.filter((p) => p.featured),
      },
    },
  },
};

// query($projectId: ID!) {
//   project(id: $projectId) {
//     // ... fields
//   }
// }

export const randomSentences = [
  "Hello we’re nine creative agency",
  "Hello we’re your new creative agency",
  "It’s time to shine.",
  "This is where the magic happens.",
  "We’re a strong strategic and creative agency with offices in Breda and Rotterdam.",
  "9|CA: Built on friendship, fueled by creativity and passion.",
  "We’ve a desire to drive real positive change through our work.",
  "With creative power and smart strategy, we help businesses take off.",
  "Bold, impactful ideas that grab attention and deliver real results.",
  "No fluff, no fuss, just creativity that works.",
  "A brand story that makes sense.",
  "What can we do for you?",
  "Where bold ideas meet sharp execution, magic happens",
  "We don’t follow trends. We set the pace for what’s next.",
  "Great design turns brands into experiences you can’t forget.",
  "Our design makes brands impossible to ignore.",
  "Timeless over trendy, always.",
  "Not just a pretty face.",
  "Great design sparks conversations.",
  "It’s all in the details.",
  "Less noise, more meaning.",
  "Make it iconic.",
  "We make campaigns that stick.",
];
